import { useParams, useRouter } from "@engaging-tech/routing"
import { useEffect } from "react"
import { connect } from "react-redux"
import { yourProfileActions } from "../../yourProfile"

const OnLoad = ({ redirectTo = "/", onLoad }) => {
  const router = useRouter()
  const { confirmToken } = useParams()
  useEffect(() => {
    onLoad(confirmToken)
    router.navigate(redirectTo)
  }, [onLoad, redirectTo, router, confirmToken])

  return null
}

const mapDispatch = dispatch => ({
  onLoad: confirmToken =>
    dispatch(yourProfileActions.confirmEmail(confirmToken))
})

/**
 * Confirms a user's email address.
 */
const ConfirmEmail = connect(null, mapDispatch)(OnLoad)

export default ConfirmEmail
